export default __webpack_public_path__ + "static/media/landscape3.50d0ad23.jpeg";